var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", [_c("Header")], 1),
      _c("el-main", [
        _c("div", { staticClass: "error" }, [
          _c("div", [_vm._v("system error")]),
          _c("div", { staticClass: "message" }, [
            _vm._v("管理者へお問合せください")
          ]),
          _c("div", { staticClass: "message" }, [
            _vm._v("status : " + _vm._s(_vm.$route.params.status))
          ]),
          _c("div", { staticClass: "message" }, [
            _vm._v("message : " + _vm._s(_vm.$route.params.message))
          ])
        ])
      ]),
      _c("el-footer", [_c("Footer")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }